import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", lineHeight: "1.6" }}>
      <h1>Política de Privacidad</h1>
      <p>
        <strong>Última actualización:</strong> Abril 2025
      </p>

      <p>
        En <strong>MamboAdmin</strong>, valoramos tu privacidad y la protección de tus datos personales. Esta Política de Privacidad explica
        qué información recopilamos, cómo la usamos y qué opciones tenés sobre tu información.
      </p>

      <h2>1. Información que recopilamos</h2>
      <ul>
        <li>Datos personales como nombre, correo electrónico y teléfono.</li>
        <li>Datos de la empresa como razón social, NIT, giro y dirección fiscal.</li>
        <li>Datos de acceso como IP, navegador y sistema operativo (con fines de seguridad).</li>
        <li>Historial de facturación y actividad dentro del sistema.</li>
      </ul>

      <h2>2. Cómo usamos tu información</h2>
      <p>Utilizamos tu información para:</p>
      <ul>
        <li>Crear y administrar tu cuenta en MamboAdmin.</li>
        <li>Emitir y gestionar comprobantes electrónicos.</li>
        <li>Brindar soporte técnico y comunicarnos con vos.</li>
        <li>Cumplir con requerimientos legales y fiscales.</li>
      </ul>

      <h2>3. Compartición de datos</h2>
      <p>No compartimos tu información personal con terceros, salvo:</p>
      <ul>
        <li>Cuando es requerido por ley o autoridad competente.</li>
        <li>Cuando usamos servicios de terceros estrictamente necesarios (como servidores de correo o almacenamiento en la nube).</li>
      </ul>

      <h2>4. Tus derechos</h2>
      <p>Tenés derecho a:</p>
      <ul>
        <li>Acceder, corregir o eliminar tu información personal.</li>
        <li>Solicitar una copia de tus datos en formato digital.</li>
        <li>Cancelar tu cuenta en cualquier momento.</li>
      </ul>
      <p>
        Para ejercer estos derechos, escribinos a <a href="mailto:soporte@mamboadmin.com">soporte@mamboadmin.com</a>.
      </p>

      <h2>5. Seguridad de los datos</h2>
      <p>Implementamos medidas técnicas y organizativas para proteger tus datos contra accesos no autorizados, uso indebido o pérdida.</p>

      <h2>6. Cambios a esta política</h2>
      <p>
        Podemos actualizar esta Política de Privacidad para reflejar cambios en nuestro servicio. Te notificaremos cualquier modificación
        importante mediante el sistema o correo electrónico.
      </p>

      <h2>7. Contacto</h2>
      <p>
        Si tenés dudas sobre esta política, podés contactarnos en <a href="mailto:soporte@mamboadmin.com">soporte@mamboadmin.com</a>.
      </p>

      <p>
        <strong>Al usar MamboAdmin, aceptás esta Política de Privacidad.</strong>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
